module.exports = __webpack_public_path__ + "img/pressalit_1.5539a9e9.jpg";